import { Component } from './component';

export interface StatusBarProps {
  fields?: string[];
}

export class StatusBar extends Component {
  public el: HTMLDivElement;

  constructor(props?: StatusBarProps) {
    super();
    this.el = document.createElement('div');
    this.el.classList.add('status-bar');

    if (props?.fields) {
      for (const field of props.fields) {
        const fieldEl = document.createElement('div');
        fieldEl.classList.add('status-bar-field');
        fieldEl.appendChild(document.createTextNode(field));
        this.el.appendChild(fieldEl);
      }
    }
  }
}
